import { Injectable } from '@angular/core';
import { Logger, LogMessage } from 'pubnub';
import { createSafeProps } from 'src/lib/tcs-app-insights/app-insights-util';
import { ConsoleLogger } from '../../tcs-logging/console-logger';
import { LoggerOptionsService } from '../../tcs-logging/logger-options.service';
import { parsePubnubLog } from '../pubnub-config';

@Injectable()
export class PubnubConsoleLogger implements Logger {
  constructor(private _logger: ConsoleLogger, private _loggerOptions: LoggerOptionsService) {}

  public error(log: LogMessage): void {
    if (this._loggerOptions.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.error(`PubnubConsoleLogger Error: ${message}`, safeLog);
    }
  }
  public info(log: LogMessage): void {
    if (this._loggerOptions.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubConsoleLogger Info: ${message}`, safeLog);
    }
  }
  public warn(log: LogMessage): void {
    if (this._loggerOptions.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.warning(`PubnubConsoleLogger Warning: ${message}`, safeLog);
    }
  }
  public debug(log: LogMessage): void {
    if (this._loggerOptions.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubConsoleLogger Debug: ${message}`, safeLog);
    }
  }
  public trace(log: LogMessage): void {
    if (this._loggerOptions.isPubnubLoggingEnabled()) {
      const { message, sanitizedLog } = parsePubnubLog(log);
      const safeLog = createSafeProps({ pubnub: sanitizedLog });
      this._logger.info(`PubnubConsoleLogger Trace: ${message}`, safeLog);
    }
  }
}
